import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import IdfSaleBlockData from '../../../Models/Content/IdfSaleBlockData';
import IdfSale from './IdfSale';

export default class IdfSaleBlock extends EpiComponent<IdfSaleBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <IdfSale context={this.getContext()} contentData={this.props.data} />;
  }
}
